import { translate } from "app/filters/i18nFilter";

import { MetricsRow, MetricTitle } from "../StyledComponent";

import { SERPFeaturesCompositionContainer } from "./serp-features-composition/SERPFeaturesCompositionContainer";
import { SERPTrafficDistribution } from "./serp-traffic-distribution/SERPTrafficDistribution";

export const SERPOppportunities = () => {
    return (
        <MetricsRow gap={"16px"}>
            <MetricTitle>{translate("wa.traffic.sources.search.seo.overview.serp.opportunities.title")}</MetricTitle>
            <MetricsRow
                direction="row"
                marginBottom="0"
            >
                <SERPTrafficDistribution />
            </MetricsRow>
            <MetricsRow direction="row">
                <SERPFeaturesCompositionContainer />
            </MetricsRow>
        </MetricsRow>
    );
};
